// Обработчик кнопки "Отмена" в формах витражных блоков
const cancelPieceForm = ({ slot, updatePiece, afterUpdateVtrgPiece, getPieceForm }) => {
  if (slot) {
    // Редактирование существующего блока — возвращаемся к его просмотру
    updatePiece(null);
    afterUpdateVtrgPiece(null);
  } else {
    // Добавление нового блока — закрываем форму
    getPieceForm(null);
  }
};

export default cancelPieceForm;
